import { ChangeDetectionStrategy, Component, OnInit, signal, inject } from '@angular/core';
import { PopoverService } from '../../../components/popover/popover.service';
import { ToolbarUserDropdownComponent } from './toolbar-user-dropdown/toolbar-user-dropdown.component';
import { DevService } from '../../../../app/services/dev.service';
import { KeycloakService } from 'src/app/auth/keycloak.service';
import { from } from 'rxjs';
import { MatRipple } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'vex-toolbar-user',
	templateUrl: './toolbar-user.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatRipple, MatIcon],
})
export class ToolbarUserComponent implements OnInit {
	private popover = inject(PopoverService);
	private impersonationService = inject(DevService);
	private keycloakService = inject(KeycloakService);

	dropdownOpen: boolean;
	firstName = signal('');
	lastName = signal('');
	keycloakProfile$;
	impersonationEvent$;

	constructor() {
		this.impersonationEvent$ = this.impersonationService.getImpersonationEvent().subscribe(() => {
			this.readName();
		});
	}

	ngOnInit() {
		this.readName();
	}

	readName() {
		this.keycloakProfile$ = from(this.keycloakService.loadUserProfile());
		const keycloakToken = this.keycloakService.getKeycloakInstance().tokenParsed;
		this.firstName.set(keycloakToken['given_name']);
		this.lastName.set(keycloakToken['family_name']);
	}

	showPopover(originRef: HTMLElement) {
		this.dropdownOpen = true;

		const popoverRef = this.popover.open({
			content: ToolbarUserDropdownComponent,
			origin: originRef,
			offsetY: 12,
			position: [
				{
					originX: 'center',
					originY: 'top',
					overlayX: 'center',
					overlayY: 'bottom',
				},
				{
					originX: 'end',
					originY: 'bottom',
					overlayX: 'end',
					overlayY: 'top',
				},
			],
		});

		popoverRef.afterClosed$.subscribe(() => {
			this.dropdownOpen = false;
		});
	}
}
